import { render } from "./NewsSkeleton.vue?vue&type=template&id=0ac0ed10"
import script from "./NewsSkeleton.vue?vue&type=script&lang=js"
export * from "./NewsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__